module.exports = __webpack_public_path__ + "media/images/arrow-down-desktop-014d1bc8c3d7013c924c584adc98fd04.png";